import React, { useState, useEffect, useMemo } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Card, CardHeader, Nav, NavItem, NavLink, CardBody, Button, Col, Input, Row, Label, ModalBody, Form, TabPane, TabContent, Spinner, FormFeedback, FormGroup, Alert, CardFooter } from 'reactstrap';
import OSelect from '../../../Components/OElements/OSelect';
import { DatePickerInput, DatesProvider } from '@mantine/dates';
import { ODataGrid } from '../../../Components/OElements/ODataGrid';
import {getRegionList } from '../../../helpers/establishment/backend_helper';


const RegistrationAndProcessing = ({
    validation,
}) => {

    return (
        <React.Fragment>
            <div>
                <h5>Registro y Tramitación</h5>
                <p className="text-muted"></p>
                </div>
                
                <div>
                    <Row className='gx-2 align-items-center'>
						<Col className='mb-3'>
                            <DatesProvider settings={{ locale: 'es-mx', firstDayOfWeek: 1, weekendDays: [0], timezone: 'UTC' }}>
                                <DatePickerInput
                                    label='Fecha Registro de Obras'
                                    id='works_registration_date'
                                    name='works_registration_date'
                                    placeholder="Seleccione una fecha"
                                    value={validation.values.works_registration_date || null}
                                    onChange={(date) => {
                                        validation.setFieldValue("works_registration_date", date);
                                    }}
                                    onBlur={validation.handleBlur}
                                    valueFormat='DD-MM-YYYY'
                                    maxDate={new Date()}
                                    error={
                                        validation.touched['works_registration_date'] &&
                                            validation.errors['works_registration_date']
                                            ? validation.errors['works_registration_date'] : ''
                                    }
                                    clearable={true}
                                />
                            </DatesProvider>
                        </Col>
                        <Col className='mb-3'>
                            <DatesProvider settings={{ locale: 'es-mx', firstDayOfWeek: 1, weekendDays: [0], timezone: 'UTC' }}>
                                <DatePickerInput
                                    label='Inicio de Tramitación y Reporte'
                                    id='report_transmission_start'
                                    name='report_transmission_start'
                                    placeholder="Seleccione una fecha"
                                    value={validation.values.report_transmission_start || null}
                                    onChange={(date) => {
                                        validation.setFieldValue("report_transmission_start", date);
                                    }}
                                    onBlur={validation.handleBlur}
                                    valueFormat='DD-MM-YYYY'
                                    maxDate={new Date()}
                                    error={
                                        validation.touched['report_transmission_start'] &&
                                            validation.errors['report_transmission_start']
                                            ? validation.errors['report_transmission_start'] : ''
                                    }
                                    clearable={true}
                                />
                            </DatesProvider>
                        </Col>                        
                    </Row>
                    <Row className='gx-2 align-items-center'>
                        <Col className='mb-3'>
                            <Label for='resolution_name' className='form-label'>
                                Nombre de Resolución
                            </Label>
                            <Input
                                name='resolution_name'
                                id='resolution_name'
                                className='form-control'
                                placeholder='Ingrese Nombre de Resolución'
                                type='text'
                                value={validation.values.resolution_name || ''}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                            />
                        </Col>
                        <Col className='mb-3'>
                            <OSelect
                                key="resolution_region_id"
                                label="Región"
                                id="resolution_region_id"
                                name="resolution_region_id"
                                value={validation.values.resolution_region_id || ''}
                                requestApi={() => getRegionList({})}
                                validation={validation}
                            />
                        </Col>

                    </Row>
                    
                </div>
        </React.Fragment>
    )
}

export default RegistrationAndProcessing;